document.addEventListener('DOMContentLoaded', () => {
    const mobileMenu = document.querySelector('.nav-container__wrapper');
    const menuToggle = document.querySelector('.hamburger');
    const svgWrapper = document.querySelector('.svg-wrapper');
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;
    const subMenus = [...mobileMenu.getElementsByClassName('nav__sub-menu')];
    const footerDropdowns = [...document.querySelectorAll('footer .dropdown')];
    const navLinksWithChildren = document.querySelectorAll('.nav__item--has-children > .nav__link');
    const backButtons = [];
	const copyBtn = document.getElementById('copy-krs-btn');
	const krsSpan = document.getElementById('krs-number');
	const floatingBtn = document.querySelector('.floating-button')
	const ctaSection = document.querySelector('.cta-actions');
	const overlay = document.querySelector('.overlay');
	if (ctaSection && floatingBtn) {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) {
						floatingBtn.classList.add('is-visible');
					} else {
						floatingBtn.classList.remove('is-visible');
					}
				});
			},
			{
				threshold: 0.1
			}
		);
		observer.observe(ctaSection);
	}

	if (copyBtn && krsSpan) {
		copyBtn.addEventListener('click', function () {
			const textToCopy = krsSpan.textContent.trim();

			navigator.clipboard.writeText(textToCopy).then(function () {
				copyBtn.innerHTML = '<i class="icon-copy"></i>Skopiowano!';
				setTimeout(() => {
					copyBtn.innerHTML = '<i class="icon-copy"></i>Skopiuj nr KRS';
				}, 2000);
			}).catch(function (err) {
				console.error('Błąd kopiowania: ', err);
			});
		});
	}

	const videoDialog = document.getElementById('video-dialog');
	const videoOpenBtn = document.getElementById('open-video-dialog');
	const videoCloseBtn = document.getElementById('close-video-dialog');
	const dialogVideo = document.getElementById('dialog-video');

	if (videoDialog && videoOpenBtn && videoCloseBtn && dialogVideo) {
		const closeVideoDialog = () => {
			videoDialog.close();
			dialogVideo.pause();
			dialogVideo.currentTime = 0;
		};

		videoOpenBtn.addEventListener('click', () => {
			videoDialog.showModal();
			dialogVideo.play().catch(() => {});
		});

		videoCloseBtn.addEventListener('click', closeVideoDialog);

		videoDialog.addEventListener('click', (e) => {
			if (e.target === videoDialog) {
				closeVideoDialog();
			}
		});
	}

	const heroVideo = document.querySelector('.fullscreen-bg__video');
	if (heroVideo && window.matchMedia('(min-width: 1024px)').matches) {
		const tryPlayHeroVideo = () => {
			heroVideo.play().catch(() => {});
		};

		tryPlayHeroVideo();
		heroVideo.addEventListener('loadeddata', tryPlayHeroVideo, { once: true });
	}

    footerDropdowns.forEach(dropdown => {
        dropdown.addEventListener('click', () => {
            const submenu = dropdown.parentElement.querySelector('.submenu');
            if (submenu) {
                submenu.classList.toggle('is-open');
            }
        });
    });


    if (!isMobile) {
        subMenus.forEach(adjustMenuPosition);
    }

	function adjustMenuPosition(subMenu) {

		const originalStyles = {
			display: subMenu.style.display,
			visibility: subMenu.style.visibility,
			opacity: subMenu.style.opacity,
			left: subMenu.style.left,
			width: subMenu.style.width,
			minWidth: subMenu.style.minWidth
		};

		subMenu.style.display = 'block';
		subMenu.style.visibility = 'hidden';
		subMenu.style.opacity = '0';
		subMenu.style.left = '0px';
		subMenu.style.width = '';

		requestAnimationFrame(() => {
			const parentItem = subMenu.closest('.nav__item');
			const parentRect = parentItem.getBoundingClientRect();
			const viewportWidth = window.innerWidth;

			const containerMaxWidth = 1248;
			const actualContainerWidth = Math.min(viewportWidth, containerMaxWidth);
			const containerLeftOffset = Math.max(0, (viewportWidth - containerMaxWidth) / 2);

			const containerRightEdge = containerLeftOffset + actualContainerWidth;

			const link = parentItem.querySelector('.nav__link');
			const isMegaMenu = link && link.textContent.trim().includes('Pomóż');

			if (isMegaMenu) {
				const subMenuWidth = subMenu.offsetWidth - 290;
				const targetScreenLeft = containerLeftOffset + (actualContainerWidth - subMenuWidth) / 2;
				const requiredLeftOffset = targetScreenLeft - parentRect.left;
				subMenu.style.left = `${requiredLeftOffset}px`;

			} else {
				subMenu.style.minWidth = '250px';
				subMenu.style.left = '0px';
				const rect = subMenu.getBoundingClientRect();
				if (rect.right > containerRightEdge) {
					const overflow = rect.right - containerRightEdge;
					subMenu.style.left = `-${overflow}px`;
				}
			}

			subMenu.style.display = originalStyles.display;
			subMenu.style.visibility = originalStyles.visibility;
			subMenu.style.opacity = originalStyles.opacity;
		});
	}



    function removeSubMenuActiveClass() {
        const activeSubMenus = document.querySelectorAll('.nav__sub-menu--active');
        mobileMenu.style.overflow = '';
        activeSubMenus.forEach(subMenu => subMenu.classList.remove('nav__sub-menu--active'));
    }

    function createBackButton(label, subMenu) {
        const backButton = document.createElement('li');
        backButton.classList.add('nav__back');

        const icon = document.createElement('i');
        icon.classList.add('icon-chevron_left');

        backButton.appendChild(icon);
        backButton.appendChild(document.createTextNode(label));

        backButton.addEventListener('click', () => {
            subMenu.classList.remove('nav__sub-menu--active');
            mobileMenu.style.overflow = '';
        });

        return backButton;
    }


    menuToggle.addEventListener('click', () => {
        menuToggle.classList.toggle('is-active');
        mobileMenu.classList.toggle('nav-container__wrapper--mobile-active');
	    mobileMenu.style = ''
        if (svgWrapper) svgWrapper.classList.toggle('is-active');
        removeSubMenuActiveClass();
    });


    navLinksWithChildren.forEach(link => {
        const parentItem = link.closest('.nav__item');
        const subMenu = parentItem.querySelector('.nav__sub-menu');
        const label = parentItem.querySelector('.nav__link').textContent;

        if (!subMenu) return;

        const backButton = createBackButton(label, subMenu);
        subMenu.insertBefore(backButton, subMenu.firstChild);
        backButtons.push(backButton);

        if (isMobile) {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                subMenu.classList.add('nav__sub-menu--active');
                mobileMenu.style.overflow = 'visible';
            });
        } else {
            parentItem.addEventListener('mouseenter', () => {
                subMenu.classList.add('nav__sub-menu--active');
				overlay.classList.add('overlay--is-visible');
                adjustMenuPosition(subMenu);
            });

            parentItem.addEventListener('mouseleave', () => {
	            overlay.classList.remove('overlay--is-visible');
                subMenu.classList.remove('nav__sub-menu--active');
            });
        }
    });

	document.querySelectorAll('.language-switcher a').forEach(function(a){
		a.addEventListener('click', function(e){
			e.preventDefault();
			var lang = this.getAttribute('data-lang');


			var url  = this.getAttribute('data-url');

			if (lang === 'pl') {

				window.location.href = url;
			} else {

				window.location.href =
					'https://translate.google.com/translate?hl=' + encodeURIComponent(lang) +
					'&sl=auto&tl=' + encodeURIComponent(lang) +
					'&u=' + encodeURIComponent(url);
			}
		});
	});
});
